import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { LogoMark } from './Logo';

/**
 * Sticky top nav. Visible on every public page.
 * Active route gets a darker color via NavLink className callback.
 */
export default function Nav() {
  const linkClass = ({ isActive }) =>
    'oc-nav__link' + (isActive ? ' is-active' : '');

  return (
    <header className="oc-nav">
      <div className="oc-shell oc-nav__inner">
        <Link to="/" className="oc-nav__logo" aria-label="OfficerCapital home">
          <LogoMark size={26} />
          <span>
            Officer<span style={{ color: 'var(--oc-green)' }}>Capital</span>
          </span>
        </Link>

        <nav className="oc-nav__links" aria-label="Primary">
          <NavLink to="/financing" className={linkClass}>Financing</NavLink>
          <NavLink to="/investors" className={linkClass}>Investors</NavLink>
          <NavLink to="/sell" className={linkClass}>Sell your company</NavLink>
          <NavLink to="/how-it-works" className={linkClass}>How it works</NavLink>
          <NavLink to="/pricing" className={linkClass}>Pricing</NavLink>
          <span className="oc-nav__divider" aria-hidden="true" />
          <a href="/app" className="oc-nav__link oc-nav__signin">Sign in</a>
          <a href="https://officercapital.com/register" className="oc-btn oc-btn--dark oc-btn--sm">List your company</a>
        </nav>
      </div>
    </header>
  );
}
